/* Open-now helper.
   Parses vendor working_hours strings like:
     - "Mon-Sat 10:00-20:00"
     - "Mon–Sat 09:00–21:00"  (EM DASH variants from seed data)
     - "Mon–Sun 10:00–22:00"
     - "All days, by appointment"  -> indeterminate (returns null)
   Evaluation happens in Asia/Kolkata time so it matches IST regardless of viewer tz.
*/

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function nowInKolkata() {
  // Compute IST clock from current instant using Intl
  const fmt = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const parts = fmt.formatToParts(new Date()).reduce((acc, p) => {
    acc[p.type] = p.value; return acc;
  }, {});
  const dayIdx = DAYS.indexOf(parts.weekday);
  const hour = parseInt(parts.hour, 10);
  const minute = parseInt(parts.minute, 10);
  return { dayIdx, minutes: hour * 60 + minute };
}

function rangeContains(dayFrom, dayTo, today) {
  // inclusive day window, wraps Sun→Sat correctly via modulo
  if (dayFrom <= dayTo) return today >= dayFrom && today <= dayTo;
  return today >= dayFrom || today <= dayTo;
}

const DASH_RE = /[\u2010-\u2015\u2212-]/g; // any unicode dash → ascii "-"
function norm(s) { return s.replace(DASH_RE, "-").replace(/\s+/g, " ").trim(); }

const TIME_RE = /(\d{1,2}):?(\d{2})\s*-\s*(\d{1,2}):?(\d{2})/;
const DAY_RE = /(Sun|Mon|Tue|Wed|Thu|Fri|Sat)\s*-\s*(Sun|Mon|Tue|Wed|Thu|Fri|Sat)/i;

/** Returns true / false / null (unknown). */
export function isOpenNow(workingHours) {
  if (!workingHours || typeof workingHours !== "string") return null;
  const s = norm(workingHours);
  if (/by appointment|by\s*app/i.test(s)) return null;

  const t = TIME_RE.exec(s);
  if (!t) return null;
  const openMin = parseInt(t[1], 10) * 60 + parseInt(t[2], 10);
  const closeMin = parseInt(t[3], 10) * 60 + parseInt(t[4], 10);

  const d = DAY_RE.exec(s);
  const dayFrom = d ? DAYS.findIndex((x) => x.toLowerCase() === d[1].toLowerCase()) : 0;
  const dayTo = d ? DAYS.findIndex((x) => x.toLowerCase() === d[2].toLowerCase()) : 6;

  const { dayIdx, minutes } = nowInKolkata();
  if (!rangeContains(dayFrom, dayTo, dayIdx)) return false;

  if (openMin <= closeMin) return minutes >= openMin && minutes < closeMin;
  // overnight (e.g. 22:00–02:00)
  return minutes >= openMin || minutes < closeMin;
}

/** Convenience for badge color: 'open' / 'closed' / 'unknown'. */
export function openNowState(workingHours) {
  const v = isOpenNow(workingHours);
  if (v === true) return "open";
  if (v === false) return "closed";
  return "unknown";
}
